import PropTypes from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import { GetFigExcelExport } from "../../../services/api/dashboard-api";
import { Accordion, Card, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import DropdownArrow from "../../../assets/icons/Icon - Dropdown Chevron - Down.svg";
import DropdownArrowDisabled from "../../../assets/icons/Icon - Chevron - Down.svg";
import DropdownUpArrow from "../../../assets/icons/Icon - Dropdown Chevron - Up.svg";
import {
  onHandleHover,
  onHandleHoverDone,
  getSetToggledFig,
  getDateColor,
  renderTableHealthcare,
  getCollapsedStatus,
  toggleAccordion,
  useSortableData,
  getBookedVacationTooltip,
  RedirectToTask,
  toggleAccordionOpen,
  NameAndBadge
} from "../../new-dashboard/dashboard-util/dashboard-utils";
import "../dashboard-fig/dashboard-fig.scss";
import "../../tasks/scenes/tasks-comments/shared-modal-header.scss";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../assets/icons/ArrowHover.svg";
import ExpandCollapseButton from "../../../components/expand-collapse-button/expand-collapse-button";
import DashboardExport from "../../../assets/icons/Icon-Dashboard-Export-32px-Blue.svg";
import { LoginContext } from "../../../services/api/authentication-api";
import { FluentAvatar } from "../../../components/FluentUI/Fluent-Avatar";

// Custom FIG Dashboard Widget
const DashboardFIG = (props) => {
  const [members, setMembers] = useState(props.items ? props.items : null);
  const [show, setShow] = useState(false);
  const [toggled, setToggled] = useState([]);
  const [seletedMember, setSeletedMember] = useState(null);
  const [accordionId] = useState("fig-accordion-"+props.type);
  const [collapsed, setCollapsed] = useState(true);
  const [juniorBankerView, setJuniorBankerView] = useState(false);
  
  const currentUser = useContext(LoginContext);

  useEffect(() => {
    if (props.items) setMembers(props.items);
    figJuniorBankerView();
  }, [props]);

  useEffect(() => {
    if (members) setToggled(getSetToggledFig(members));
  }, [members]);

  const showModal = (m) => {
    if(m.TableVacation && m.TableVacation[0]?.Rows?.length>0){
      setShow(true);
      setSeletedMember(m);
    }
  };

  const figJuniorBankerView = () => {
    if(members?.length === 1 && members[0]?.MemberId === currentUser.userID){
      setJuniorBankerView(true);
      toggleAccordionOpen(accordionId + "-" + members[0]?.Id);
    }
  }

  const onHide = () => setShow(false);

  const { items, requestSort, getArrowDirectionFor } = useSortableData(members);

  const renderTableVacation = (table) => {
    if(table && table[0].Rows.length > 0){
      let result = (
        <div>
          {renderTableHealthcare(table, false, false, false, 0)}
        </div>
      );
      return result;
    }
  };

  const hourformat = (data) => {
    let intData = +data;
    if(intData <= 0){
      return "-";
    } else {
      let hours = Math.floor(intData);
      let decimalPart = intData - hours;
      let minutes = 60 * decimalPart;
      return hours.toString()+ "h " + minutes + "m";
    }
  }

  if (items != null && items.length > 0) {
    return (
      <div className="new-dashboard table-wrapper">
        <div className="DashboardTableWrapper">
          <table>
            <thead>
              <tr className="DashboardTableHeader">
                <th className="DashboardTableTitle">
                Project, Deals and Vacations · {props.type}s
                <div className="DashboardTableHeaderButtons">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Export Data</Tooltip>}
                   >
                      <img src = {DashboardExport} onClick={() => GetFigExcelExport(props.type)}/>
                    </OverlayTrigger>
                    {!juniorBankerView &&<ExpandCollapseButton accordionId={accordionId} collapsed={collapsed} setCollapsed={setCollapsed} toggled={toggled} setToggled={setToggled}/>}
                  </div>
                  <p className="subDepartmentTitle">Financial Institutions Group</p>
                </th>
              </tr>
            </thead>

            {/* Project and Deals table  */}
            <div className="scrollable-dashboard">
              <Accordion>
                <Card className="MemberTableBodyWrapper sticky-header-dashboard">
                  <thead className="MemberTableColumnHeader">
                    <tr className="MemberTableColumnTitles">
                      <th className="col-md-2 textEllipsis headerSorted">
                      <div onClick={() => requestSort('Member')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted"> MEMBER</p>
                              </div>
                              {
                                getArrowDirectionFor("Member", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Member", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Member") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      <th className="col-md-2 textEllipsis headerSorted">
                      <div onClick={() => requestSort('ExpectedTotalHoursThisWeek')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">EXPECTED TOTAL HOURS THIS WEEK</p>
                              </div>
                              {
                                getArrowDirectionFor("ExpectedTotalHoursThisWeek", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("ExpectedTotalHoursThisWeek", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("ExpectedTotalHoursThisWeek") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      <th className="col-md-2  textEllipsis headerSorted">
                      <div onClick={() => requestSort('TotalHoursLastWeek')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">TOTAL HOURS LAST WEEK</p>
                              </div>
                              {
                                getArrowDirectionFor("TotalHoursLastWeek", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("TotalHoursLastWeek", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("TotalHoursLastWeek") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      <th className="col-md-2 pr-5 textEllipsis headerSorted">
                      <div onClick={() => requestSort('TotalWeekendHoursLastWeek')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">TOTAL WEEKEND HOURS LAST WEEK</p>
                              </div>
                              {
                                getArrowDirectionFor("TotalWeekendHoursLastWeek", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("TotalWeekendHoursLastWeek", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("TotalWeekendHoursLastWeek") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                      </th>
                      {getBookedVacationTooltip(<th className="col-md-3 textEllipsis headerSorted">
                      <div onClick={() => requestSort('UpcomingVacationPTO')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">UPCOMING VACATION/PTO</p>
                              </div>
                              {
                                getArrowDirectionFor("UpcomingVacationPTO", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("UpcomingVacationPTO", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("UpcomingVacationPTO") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>

                      </th>)}
                      <th className="col-md-1"></th>
                    </tr>
                  </thead>
                </Card>
                <table>
                  <tbody className="healthcare-tablebody">
                    {items &&
                      items.map((m) => {
                        return (
                          <tr key={m?.Id} className="healthcare-table-row">
                            <Card>
                              <div className="MemberTableBody overrideDashboardMargin row">                                
                                <td className="col-md-2 mt-2 dashboard-username">
                                  <FluentAvatar size={32} name={m?.Member} className="task-member-user"/>                                
                                  {
                                    juniorBankerView
                                    ?
                                      <NameAndBadge name={m.Member} />
                                    :
                                      <span className="Memberoverlaybutton mt-1 pl-1">
                                        {m.Member}
                                      </span>
                                  }
                                </td>
                                <td className="col-md-2 mt-2">
                                  {hourformat(m.ExpectedTotalHoursThisWeek)}
                                </td>
                                <td className="col-md-2 mt-2">
                                  {hourformat(m.TotalHoursLastWeek)}
                                </td>

                                <td className="col-md-2 mt-2">
                                  {hourformat(m.TotalWeekendHoursLastWeek)}
                                </td>

                                <td
                                  onMouseLeave={(e) => {if(m.TableVacation && m.TableVacation[0]?.Rows?.length>0) onHandleHoverDone(e)}}
                                  onMouseEnter={(e) => {if(m.TableVacation && m.TableVacation[0]?.Rows?.length>0) onHandleHover(e)}}
                                  onClick={() => showModal(m)}
                                  className={m.TableVacation && m.TableVacation[0]?.Rows?.length>0 ? "col-md-3 mt-2 healthcare-dates":  "col-md-3 mt-2 healthcare-dates-disabled"}
                                  style={{
                                    color: getDateColor(m.UpcomingVacationPTO[0]),
                                  }}
                                >
                                  {m.UpcomingVacationPTO[1]} - {m.UpcomingVacationPTO[2]}
                                </td>
                                {m?.TableDeals?.length > 0  && m.TableDeals[0]?.Rows?.length > 0 && toggled? (
                                  <td className="col-md-1 healthcare-toogle">
                                    <RedirectToTask CanEdit = {m.CanEdit} TaskId={m.Id} TaskName={m.TaskName}></RedirectToTask>
                                    {(!toggled?.filter(t => t.UserID == m.Id)[0] ? false : toggled?.filter(t => t.UserID == m.Id)[0].Toggled) ? (
                                      <div className="healthcare-button-row"
                                        onClick={(e) => {
                                          if(m.TableDeals.length > 0 && !juniorBankerView){
                                            let updatedToggled = toggled?.map((t) => {
                                              if(t.UserID == m.Id){
                                                t.Toggled = false;
                                              }
                                              return t;
                                            });
                                            toggleAccordion(accordionId + "-" + m.Id);
                                            setToggled(updatedToggled)
                                            setCollapsed(getCollapsedStatus(accordionId))
                                          }
                                        }}
                                        >
                                          <img
                                            disabled = {juniorBankerView}
                                            className="dropdown-up-arrow"
                                            alt="dropdown-arrow"
                                            src={DropdownUpArrow}
                                          />
                                      </div>
                                    ) : (
                                      <div className="healthcare-button-row"
                                        onClick={(e) => {
                                          if(m.TableDeals.length > 0 && !juniorBankerView){
                                            let updatedToggled = toggled?.map((t) => {
                                              if(t.UserID == m.Id){
                                                t.Toggled = true;
                                              }
                                              return t;
                                            });
                                            toggleAccordion(accordionId + "-" + m.Id);
                                            setToggled(updatedToggled)
                                            setCollapsed(getCollapsedStatus(accordionId))
                                          }
                                        }}
                                      >
                                        <img
                                          disabled = {juniorBankerView}
                                          className="dropdown-arrow"
                                          alt="dropdown-arrow"
                                          src={m.TableDeals.length > 0 ? DropdownArrow : DropdownArrowDisabled}
                                        />
                                      </div>
                                    )}
                                  </td>
                                ) : (
                                  <td className="col-md-1 healthcare-toogle-empty">                                    
                                    <RedirectToTask CanEdit = {m.CanEdit} TaskId={m.Id} TaskName={m.TaskName}></RedirectToTask>
                                    <div className="healthcare-button-row">
                                      <img
                                        className="dropdown-arrow"
                                        alt="dropdown-arrow"
                                        src={DropdownArrowDisabled}
                                      />
                                    </div>
                                  </td>
                                )}
                              </div>

                              {/* Dropdown For Deals Tables */}
                              <Accordion.Collapse
                                eventKey={m.Id}
                                scrollable={true}
                                className={"scrollable-dashboard " + accordionId}
                                id={accordionId + "-" + m.Id}
                              >
                                <Card.Body
                                  scrollable={true}
                                  className="scrollable-dashboard scrollable-power-deals"
                                >
                                  {m.TableDeals[0]?.Rows?.length > 0 && renderTableHealthcare(m.TableDeals, true, true)}
                                </Card.Body>
                              </Accordion.Collapse>                              
                            </Card>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </Accordion>
            </div>
          </table>
          {seletedMember 
            && (<Modal
                  key={seletedMember?.Id}
                  show={show}
                  onHide={onHide}
                  contentClassName="deal-and-vacation-date-healthcare-modal-styles"
                  dialogClassName="deal-and-vacation-date-healthcare-modal"
                  backdropClassName="healthcare-modal-backdrop"
                  scrollable={true}
                >
                  <div className="popup-week">
                    <Modal.Header
                      className="header-popup"
                      closeButton
                    >
                      <Modal.Title className="dashboard-modal-title ml-4 ">
                        <div class="modalFIGTitleContainer">
                          <p class="modalFIGTitle">{seletedMember?.Member}</p>
                          <p class="modalFIGSubtitle">Vacations and PTO Tracker</p>
                        </div>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="header-body">
                      {renderTableVacation(
                        seletedMember.TableVacation
                      )}
                    </Modal.Body>
                  </div>
                </Modal>
          )}
        </div>
      </div>
    );
  }
  return null;
};

DashboardFIG.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.string,
};

export default DashboardFIG;
